'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targeting = undefined;

var _search = require('./targeting/search');

var _search2 = _interopRequireDefault(_search);

var _GooglePublisherTag = require('./GooglePublisherTag/GooglePublisherTag');

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _GooglePublisherTag2.default;
var targeting = exports.targeting = {
  search: _search2.default
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-react-gpt/build/index.js
 ** module id = 834
 ** module chunks = 0
 **/